var map = {
	"../auth/auth.module": [
		"./src/app/modules/auth/auth.module.ts",
		"auth-auth-module"
	],
	"../policy/policy.module": [
		"./src/app/modules/policy/policy.module.ts",
		"policy-policy-module"
	],
	"./../company/company.module": [
		"./src/app/modules/company/company.module.ts",
		"default~company-company-module~user-user-module",
		"company-company-module"
	],
	"./../user/user.module": [
		"./src/app/modules/user/user.module.ts",
		"default~company-company-module~user-user-module",
		"user-user-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;